import { QueryKeys } from "@/constants/Query";
import { AdherenceStatus } from "@/features/Patient/MedicalRecords/MedicationsAllergies/network/useMedications";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { wildcardInvalidateQuery } from "@/lib/utils";
import { useQueryClient } from "@tanstack/react-query";

interface ManualRoutePrescriptionParams {
  routingMethod: string;
}

interface ManualRoutePrescriptionResponse {
  bundle: object;
}

export const useManualRoutePrescription = ({
  patientId,
  encounterId,
  medicationRequestId,
}: {
  patientId: string;
  encounterId: string;
  medicationRequestId: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<
    ManualRoutePrescriptionResponse,
    ManualRoutePrescriptionParams
  >({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chart.Prescriptions.MARK_ROUTED(
        patientId,
        encounterId,
        medicationRequestId,
      ),
      mutationFn: (params) => {
        return axiosInstance.post(
          `/rx/prescriptions/${medicationRequestId}/mark-routed`,
          params,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Prescriptions.DEFAULT(
            patientId,
            encounterId,
          ),
        });
        queryClient.invalidateQueries({
          queryKey:
            QueryKeys.Patient.MedicalRecords.Medications.ADHERENCE_SECTION(
              AdherenceStatus.ACTIVE,
              patientId,
            ),
        });
        wildcardInvalidateQuery(
          queryClient,
          QueryKeys.Distribution.AVAILABLE_ACTIONS({
            patientId,
            encounterId: "*",
          }),
        );
      },
    },
  });
};
